import { publicOperationMiddleware } from '../../../permissions/middlewares/publicOperationMiddleware.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { resolveGetSuSRegistrationDataForStudent } from '../server/resolveGetSuSRegistrationDataForStudent.js';

@Entity()
export class SuSRegistrationDataForStudent extends AdornisEntity {
  static override _class = 'SuSRegistrationDataForStudent';

  @Field(type => String)
  email!: string;

  @Field(type => String)
  schoolID!: string;

  @Field(type => String)
  userID: Maybe<string>;

  @Field(type => String)
  childID: Maybe<string>;

  @Field(type => String)
  klasse!: string;

  @Field(type => String)
  origin!: string;

  /** the school sent this link to correct an existing application, the guardian is logged in by it */
  @Field(type => Boolean)
  update: Maybe<boolean>;
}

export const getSuSRegistrationDataForStudent = registerQuery({
  operationName: 'getSuSRegistrationDataForStudent',
  middlewares: [publicOperationMiddleware('Durch signiertes SUS_REGISTRATION-Token geschuetzt')],
  type: () => SuSRegistrationDataForStudent,
  params: [{ type: () => String, name: 'token' }],
  resolve: resolveGetSuSRegistrationDataForStudent,
});
